// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_lZ1","cls2":"SingularMentionCitationModal-cls2_YLc SingularMentionCitationModal-cls1_lZ1"};